import {HStack, Stack, StackProps, Text, VStack} from "@chakra-ui/react";
import * as React from "react";
import {JSX} from "react";
import {CardIcon} from "../CardIcon/CardIcon";

export interface RecapCardProps extends StackProps {
    name?: string;
    counter?: number;
    icon?: JSX.Element;
    firstButtonClick?: () => void;
    secondButtonClick?: () => void;
}

export const RecapCard = ({name, counter, icon, firstButtonClick, secondButtonClick, ...props}: RecapCardProps) => {
    return <VStack flex={1}
                   h={"100%"}
                   spacing={0}
                   overflow={"hidden"}
                   backgroundColor={"primary.400"}
                   borderRadius={"16px"}
                   {...props}>
        <HStack
            w={"100%"}
            h={"100%"}
            overflow={"hidden"}
            justifyItems={"center"}
            alignItems={"center"}>
            <Stack h={"184px"} ps={"16px"} justifyContent={"center"} alignItems={"center"}>
                <CardIcon icon={icon}/>
            </Stack>
            <HStack w={"100%"} alignSelf={"stretch"} p={"0px"}>
                <Text m="auto" fontSize={"20px"} fontWeight={"bold"} textColor={"rgba(255,255,255,0.8)"}>{name}</Text>
                <Stack h={"100%"} w={"94px"} px="16px" justifyContent={"center"} alignItems={"center"} spacing={0}
                       backgroundColor={"rgba(255,255,255,0.1)"}>
                    <Text fontWeight={"bold"} fontSize={"32px"} textColor={"white"}>{counter || 0}</Text>
                </Stack>
            </HStack>
        </HStack>
        <HStack w={"100%"} spacing={0}>
            <Stack flex={1} p={"16px"} cursor={"pointer"} _hover={{backgroundColor: "rgba(255,255,255,0.1)"}}
                   backgroundColor={"rgba(0,0,0,0.2)"} onClick={firstButtonClick}>
                <Text textColor={"white"} textAlign={"center"}>Visualizza</Text>
            </Stack>
            <Stack flex={1} p={"16px"} cursor={"pointer"} _hover={{backgroundColor: "rgba(255,255,255,0.1)"}}
                   backgroundColor={"rgba(0,0,0,0.2)"} onClick={secondButtonClick}>
                <Text textColor={"white"} textAlign={"center"}>Aggiungi</Text>
            </Stack>
        </HStack>
    </VStack>
}
